const KEY = "owt_attribution";
const LEAD_KEY = "owt_lead_sent";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};

export const captureAttribution = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const ref = document.referrer && !document.referrer.includes(window.location.host) ? document.referrer.slice(0, 300) : "";
    const utm_source = (p.get("utm_source") || "").slice(0, 100);
    if (!utm_source && !ref && localStorage.getItem(KEY)) return;
    localStorage.setItem(KEY, JSON.stringify({
      utm_source, utm_medium: (p.get("utm_medium") || "").slice(0, 100),
      utm_campaign: (p.get("utm_campaign") || "").slice(0, 100), referrer: ref,
    }));
  } catch { /* storage blocked */ }
};

export const getAttribution = () => ({ utm_source: "", utm_medium: "", utm_campaign: "", referrer: "", ...read(), source_page: window.location.pathname.slice(0, 200) });

export const markLeadSent = () => { try { localStorage.setItem(LEAD_KEY, "1"); } catch { /* ignore */ } };
export const leadSent = () => { try { return !!localStorage.getItem(LEAD_KEY); } catch { return false; } };

export const onceFlag = (key) => {
  try {
    if (localStorage.getItem(key)) return false;
    localStorage.setItem(key, "1");
    return true;
  } catch { return false; }
};
